import { ConsultantLeadStatusCustom, NextContactDateReason } from "@bonliva-crm/graphql";
import * as yup from "yup";

export type FormInput = {
  leadStatus: ConsultantLeadStatusCustom;
  nextContactDate: Date;
  reason: NextContactDateReason;
  reasonComment: string;
  isResponsibleHBA: boolean;
};

export const getDefaultValues = (
  newLeadStatus?: ConsultantLeadStatusCustom
): FormInput => {
  return {
    leadStatus: newLeadStatus ?? ConsultantLeadStatusCustom.BadTiming,
    nextContactDate: null,
    reason: NextContactDateReason.WorksForCompetitor,
    reasonComment: null,
    isResponsibleHBA: false
  };
};

export const validationSchema = yup.object<FormInput>({
  leadStatus: yup.mixed().oneOf(Object.values(ConsultantLeadStatusCustom)).required(),
  nextContactDate: yup.date().nullable(true).when("leadStatus", {
    is: ConsultantLeadStatusCustom.RelevantLater,
    then: yup.date().required()
  }),
  reason: yup
    .mixed()
    .oneOf(Object.values(NextContactDateReason))
    .nullable(true)
    .when("leadStatus", {
      is: ConsultantLeadStatusCustom.RelevantLater,
      then: yup.mixed().oneOf(Object.values(NextContactDateReason)).required()
    }),
  reasonComment: yup
    .string()
    .nullable(true)
    .when(
      ["leadStatus", "reason"],
      (leadStatus: ConsultantLeadStatusCustom, reason: NextContactDateReason) => {
        if (
          leadStatus === ConsultantLeadStatusCustom.RelevantLater &&
          reason === NextContactDateReason.Other
        ) {
          return yup.string().max(1000).required();
        }
      }
    ),
  isResponsibleHBA: yup.boolean().required()
});
